<template>
	<div class="alert-countdown" role="alert">
		<bg-icon name="time-glyph" class="bg-u-text-yellow-500" />

		<bg-text
			size="label-2"
			class="bg-u-ml-md bg-u-text-yellow-700"
			data-testid="alertCountdown-textContent"
		>
			{{ description }}
		</bg-text>
	</div>
</template>

<script>
import { BgIcon, BgText } from 'bangul-vue';

export default {
	components: {
		BgIcon,
		BgText,
	},

	props: {
		description: {
			type: String,
			default: ''
		}
	}
}
</script>

<style lang="scss" scoped src="./AlertCountdown.scss" />
